import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Crown, Users, Rocket, LineChart } from "lucide-react";
import { useTranslation } from "react-i18next";

interface BoostProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  userRole: "talent" | "recruiter";
}

export const BoostProfileModal = ({ isOpen, onClose, userRole }: BoostProfileModalProps) => {
  const { t } = useTranslation();

  const perks = {
    talent: [
      {
        icon: <Crown className="w-5 h-5 text-purple-500" />,
        title: t('boost.talent.priority_applications'),
        description: t('boost.talent.priority_applications_desc')
      },
      {
        icon: <LineChart className="w-5 h-5 text-purple-500" />,
        title: t('boost.talent.feed_visibility'),
        description: t('boost.talent.feed_visibility_desc')
      },
      {
        icon: <Users className="w-5 h-5 text-purple-500" />,
        title: t('boost.talent.directory_placement'),
        description: t('boost.talent.directory_placement_desc')
      }
    ],
    recruiter: [
      {
        icon: <Users className="w-5 h-5 text-purple-500" />,
        title: t('boost.recruiter.directory_placement'),
        description: t('boost.recruiter.directory_placement_desc')
      },
      {
        icon: <LineChart className="w-5 h-5 text-purple-500" />,
        title: t('boost.recruiter.feed_visibility'),
        description: t('boost.recruiter.feed_visibility_desc')
      },
      {
        icon: <Rocket className="w-5 h-5 text-purple-500" />,
        title: t('boost.recruiter.opportunity_placement'),
        description: t('boost.recruiter.opportunity_placement_desc')
      }
    ]
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center">
            {t('boost.title')}
          </DialogTitle>
        </DialogHeader>
        
        <div className="mt-6">
          <div className="text-center mb-6">
            <p className="text-muted-foreground">
              {t('boost.description')}
            </p>
          </div>

          <div className="space-y-4">
            {perks[userRole].map((perk, index) => (
              <Card key={index} className="border border-purple-100 hover:border-purple-200 transition-colors">
                <CardContent className="p-4 flex items-start gap-4">
                  <div className="p-2 bg-purple-50 rounded-lg">
                    {perk.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">{perk.title}</h3>
                    <p className="text-muted-foreground text-sm">{perk.description}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="mt-8 flex justify-end gap-3">
            <Button variant="outline" onClick={onClose}>
              {t('common.cancel')}
            </Button>
            <Button 
              className="bg-[#9b87f5] hover:bg-[#7E69AB] text-white"
              onClick={() => console.log("Continue to boost settings")}
            >
              {t('common.continue')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};